// Maps `source` values for complaints, as stored in the `complaints` table in the database to human-friendly readable
// ones. Unmapped values are shown as-is.
export const COMPLAINT_SOURCES = {
  complaint_portal: 'Complaint Portal',
  hotline: 'Hotline',
  cuore: 'Call Center',
};

export const COMPLAINT_FIELDS = {
  STATUS: 'status',
};

export const COMPLAINTS_COL_IDS = {
  complaintTypes: 'complaintTypes',
  status: 'status',
};
